import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_VALIDATE_SUB_ITEM_BEGIN,
  MANAGE_SUBS_VALIDATE_SUB_ITEM_SUCCESS,
  MANAGE_SUBS_VALIDATE_SUB_ITEM_FAILURE,
  MANAGE_SUBS_VALIDATE_SUB_ITEM_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function validateSubItem(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_VALIDATE_SUB_ITEM_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
     
      const doRequest = axios.post(`${API_REQUEST_URL}/validateSubItem`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_VALIDATE_SUB_ITEM_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_VALIDATE_SUB_ITEM_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissValidateSubItemError() {
  return {
    type: MANAGE_SUBS_VALIDATE_SUB_ITEM_DISMISS_ERROR,
  };
}

export function useValidateSubItem() {
  const dispatch = useDispatch();

  const { validateSubItemPending, validateSubItemError } = useSelector(
    state => ({
      validateSubItemPending: state.manageSubs.validateSubItemPending,
      validateSubItemError: state.manageSubs.validateSubItemError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(validateSubItem(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissValidateSubItemError());
  }, [dispatch]);

  return {
    validateSubItem: boundAction,
    validateSubItemPending,
    validateSubItemError,
    dismissValidateSubItemError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_VALIDATE_SUB_ITEM_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        validateSubItemPending: true,
        validateSubItemError: null,
      };

    case MANAGE_SUBS_VALIDATE_SUB_ITEM_SUCCESS:
      // The request is success
      return {
        ...state,
        validateSubItemPending: false,
        validateSubItemError: null,
      };

    case MANAGE_SUBS_VALIDATE_SUB_ITEM_FAILURE:
      // The request is failed
      return {
        ...state,
        validateSubItemPending: false,
        validateSubItemError: action.data.error,
      };

    case MANAGE_SUBS_VALIDATE_SUB_ITEM_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        validateSubItemError: null,
      };

    default:
      return state;
  }
}
